import script from "./ServicePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicePage.vue?vue&type=script&setup=true&lang=js"

import "./ServicePage.vue?vue&type=style&index=0&id=80c02d36&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80c02d36"]])

export default __exports__